const validateResponse = (data, error, serviceIdentifier) => {
  return (!serviceIdentifier || !data || error || !(data.techShedReviews)
   || data?.techShedReviews.reviews.length === 0);
};

export { validateResponse };